function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_9538_24812)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.833 9.16406L18.333 1.66406M18.333 1.66406H13.8799M18.333 1.66406V6.11719",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.3337 9.9974C18.3337 13.9258 18.3337 15.89 17.1133 17.1103C15.8929 18.3307 13.9287 18.3307 10.0003 18.3307C6.07195 18.3307 4.10777 18.3307 2.88738 17.1103C1.66699 15.89 1.66699 13.9258 1.66699 9.9974C1.66699 6.06902 1.66699 4.10484 2.88738 2.88445C4.10777 1.66406 6.07195 1.66406 10.0003 1.66406",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_9538_24812"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  rx: 4.16667
})));

var SvgSquareLink = function SvgSquareLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSquareLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/square-link.04ce0a0d.svg";
export { ForwardRef as ReactComponent };